<script setup>
import { state, voucherCredit } from '@/shared/basketStore.js';
import { openPanel } from '@/shared/panelStack.js';
import BasketPanel from '@/components/BasketPanel.vue';
import SvgIcon from '@/components/SvgIcon.vue';
import { formatPrice } from '@/shared/formatPrice.js';

// The header's basket button. Was SidebarApp.vue, which also rendered the drawer itself
// with its own placeholder styling in a scoped block; the panel is now PopOutPanel.vue,
// rendered by PopOutPanelHost.vue from the shared stack, so nothing is left here but the
// button, its count, and the voucher credit beside it.
//
// Styled by button.basket in resources/css/frontend/includes/form.scss, alongside its
// header sibling button.hamburger. `plain` opts out of the base button skin.
//
// The credit label is a SIBLING of the button rather than a child: button.basket is a
// fixed 40px square with the count badge absolutely positioned inside it, so a text
// child would either overflow that square or collide with the badge. Two roots is fine
// here - #basket-button's parent .header_right is already a flex row (header.scss), so
// the label and the button lay out as flex siblings with no wrapper of their own.

function showBasket() {
    openPanel({ component: BasketPanel, title: 'Your Basket' });
}
</script>

<template>
    <!-- Not a button: the figure is a statement about the order, and the basket panel
         beside it is already the way to act on it.
         "credit" is its own span so the narrow header can drop the word and keep the
         figure - form.scss hides it below `large`, visually only, so it is still
         announced. No whitespace between the two spans; the word carries its own
         leading space, which a clipped span would otherwise collapse away. -->
    <span v-if="voucherCredit" class="basket_credit"
        >{{ formatPrice(voucherCredit) }}<span class="basket_credit_word"> credit</span></span
    >

    <button type="button" class="basket plain" aria-label="Basket" @click="showBasket">
        <SvgIcon name="bag" />
        <span v-if="state.basket.items.length" class="count">{{ state.basket.items.length }}</span>
    </button>
</template>
